import api from '../index'

const rateService = {
    // List all items
    getRates: async (params) => {
        try {
            const res = await api.get('/api/v1/admin/rates', { params })
            return { success: true, data: res.data.data }
        } catch (error) {
            const errorMessage = error.response?.data?.message || 'Failed to fetch items'
            console.error('API call failed:', error)
            return { success: false, message: errorMessage, error }
        }
    },

    // Update an existing item
    updateRate: async (id, data) => {
        try {
            const res = await api.put(`/api/v1/admin/rates/${id}`, { rate: data })
            return { success: true, data: res.data.data }
        } catch (error) {
            return { success: false, messages: error.response?.data, error }
        }
    },
}

export default rateService
